import React from "react"

import type { BadgeProps } from "@chakra-ui/react"
import { Badge } from "@chakra-ui/react"

import { toSentenceCase } from "@supliful/domain"

const statusColors = {
  NEW: "yellowBright",
  PROCESSING: "yellowBright",
  ACCEPTED: "primary",
  IN_PROGRESS: "primary",
  COMPLETED: "primary",
  CANCELED: "red",
  RETURNED: "yellowBright",
  // Line statuses PodHero reports; NEW is shared with orders.
  BATCHED: "primary",
  PRELABELED: "primary",
  DECORATED: "primary",
  BINNED: "primary",
  SHIPPED: "primary",
  // A failed QC unit is held back for rework, so it reads as a problem.
  QC_FAIL: "red",
} as const

type OrderStatus = keyof typeof statusColors

/** Statuses `toSentenceCase` would mangle (acronyms it lower-cases). */
const statusLabels: Record<string, string> = {
  QC_FAIL: "QC fail",
}

type StatusBadgeProps = BadgeProps & {
  status: OrderStatus | string
}

export const StatusBadge = ({ status, ...rest }: StatusBadgeProps) => {
  // Type guard to check if status is valid
  const color =
    status in statusColors ? statusColors[status as OrderStatus] : "gray" // Fallback color for unknown statuses

  return (
    <Badge colorScheme={color} {...rest}>
      {statusLabels[status] ?? toSentenceCase(status)}
    </Badge>
  )
}
